<template>
  <div class="menu">
    <h1 class="h1 mt0 mb60 text-center">{{$route.meta.title}}</h1>
    <div class="menu__items">
      <div class="menu__item"
                   v-for="item in items"
                   :key="item.name"
      >
        <router-link :to="{name: item.to}" class="block__link"></router-link>
        <div class="menu__img">
          <img :src="item.img" :width="item.imgWidth" alt="">
        </div>
        <span v-html="item.name"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Menu",
    data() {
      return {
        items: [
          {
            name: 'Конструктор <br> карты',
            img: 'img/menu1.svg',
            to: 'designer-brands',
            imgWidth: 116
          },
          {
            name: 'Справочник <br> вопросов',
            img: 'img/menu2.svg',
            to: 'questions',
            imgWidth: 126
          },
          {
            name: 'Проверка <br> карты',
            img: 'img/menu3.svg',
            to: 'check-brands',
            imgWidth: 140
          }
        ]
      }
    },
  }
</script>

<style lang="scss">
  @import "../style/var";

  .menu {
    padding: 150px 0;
    @media (max-width: 575px) {
      padding: 60px 0;
    }
    &__items {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      @media (max-width: 575px) {
        margin-top: -50px;
      }
    }
    &__item {
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 20px 60px;
      font-size: 22px;
      font-weight: 500;
      @media (max-width: 575px) {
        text-align: center;
        font-size: 20px;
      }
    }
    &__img {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 180px;
      @media (max-width: 575px) {
        height: 150px;
        img {
          max-width: 125px;
        }
      }
    }
  }
</style>